module.exports = __webpack_public_path__ + "img/Alluraa-Influencer-Tile-03.d9255141.png";